import React from 'react';
import { ExchangeOrderHeader } from './ExchangeOrderHeader';
import { ExchangeOrderLineItems } from './ExchangeOrderLineItems';
import { ExchangeOrderFooter } from './ExchangeOrderFooter';
export function ExchangeOrder() {
  const companyInfo = {
    name: 'MyTourix Travel Management',
    address: ['123 Orchard Road, #12-34', 'Singapore 238858'],
    phone: '+65 6789 1234',
    fax: '+65 6789 1235',
    email: 'accounts@mytourix.com',
    uen: '201234567G'
  };
  const exchangeOrderInfo = {
    number: 'EO-2025-00156',
    supplierNo: 'SUP-8821',
    date: '20 January 2025',
    soRef: 'SO-2025-TR-445',
    staff: 'Sarah Chen',
    isDuplicate: false
  };
  const supplier = {
    name: 'Grand Hyatt Singapore',
    address: ['10 Scotts Road', 'Singapore 228211'],
    attn: 'Reservations Department',
    tel: '+65 6738 1234',
    fax: '+65 6732 1696'
  };
  const items = [{
    itemNumber: 1,
    itemType: 'Hotel',
    description: [{
      label: 'City / Hotel',
      value: 'Singapore / Grand Hyatt Singapore'
    }, {
      label: 'Check-In Date',
      value: '15 FEB 2025'
    }, {
      label: 'Check-Out Date',
      value: '22 FEB 2025'
    }, {
      label: 'Room Type',
      value: 'Grand Deluxe King'
    }, {
      label: 'Room Category',
      value: 'City View'
    }, {
      label: 'Status',
      value: 'Confirmed'
    }, {
      label: 'Room / Night',
      value: '1 Room x 7 Nights'
    }],
    passengers: ['LEOW/GUAT TIN MS', 'SIM/KIM WAH MR'],
    unitPrice: 231.89,
    currency: 'SGD',
    quantity: 7,
    tax: 0.0,
    amount: 1623.23
  }];
  const totals = {
    amount: 1623.23,
    tax: 0.0,
    lessPaidAmount: 0.0,
    total: 1623.23
  };
  return <div className="h-full overflow-auto bg-gradient-to-br from-neutral-50 to-neutral-100 p-6" data-id="element-273">
      <div className="w-[210mm] min-h-[297mm] max-h-[297mm] mx-auto bg-white shadow-lg rounded-xl p-8 flex flex-col" data-id="element-274">
        <ExchangeOrderHeader company={companyInfo} exchangeOrder={exchangeOrderInfo} supplier={supplier} data-id="element-275" />

        <div className="flex-1 overflow-hidden" data-id="element-276">
          <ExchangeOrderLineItems items={items} data-id="element-277" />

          {/* Totals Summary */}
          <div className="flex justify-end mb-6" data-id="element-278">
            <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-5 min-w-[320px] shadow-sm" data-id="element-279">
              <div className="space-y-2.5" data-id="element-280">
                <div className="flex justify-between items-center" data-id="element-281">
                  <span className="text-xs font-medium text-neutral-600" data-id="element-282">
                    Amount:
                  </span>
                  <span className="text-xs text-neutral-900 font-mono tabular-nums" data-id="element-283">
                    {totals.amount.toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between items-center" data-id="element-284">
                  <span className="text-xs font-medium text-neutral-600" data-id="element-285">
                    Tax:
                  </span>
                  <span className="text-xs text-neutral-900 font-mono tabular-nums" data-id="element-286">
                    {totals.tax.toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between items-center" data-id="element-287">
                  <span className="text-xs font-medium text-neutral-600" data-id="element-288">
                    Less Paid Amount:
                  </span>
                  <span className="text-xs text-neutral-900 font-mono tabular-nums" data-id="element-289">
                    {totals.lessPaidAmount.toFixed(2)}
                  </span>
                </div>
                <div className="h-px bg-neutral-300" data-id="element-290" />
                <div className="flex justify-between items-center bg-blue-50 border border-blue-200 -mx-5 px-5 py-2.5 rounded" data-id="element-291">
                  <span className="text-sm font-bold text-neutral-900" data-id="element-292">
                    Total:
                  </span>
                  <span className="text-base font-bold text-blue-700 font-mono tabular-nums" data-id="element-293">
                    SGD {totals.total.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <ExchangeOrderFooter formOfPayment="C.O.D." invoiceRefs={['INV-2025-00234', 'INV-2025-00267']} remarks="Exchange processed for hotel booking. Please confirm receipt of this exchange order." authorization={{
          approvedBy: '',
          checkedBy: '',
          chequeNo: ''
        }} data-id="element-294" />
        </div>
      </div>
    </div>;
}